import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../utils/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#0D2436] shadow-xl py-2' 
          : 'bg-[#0D2436]/95 backdrop-blur-sm py-3'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="/vitanza-logo.png" 
              alt="Vitanza Logistics" 
              className="h-14 w-14 md:h-16 md:w-16 object-contain"
            />
            <div className="flex flex-col">
              <span className="text-[#F5E6D3] font-bold text-xl md:text-2xl tracking-wide">
                {companyInfo.name}
              </span>
              <span className="text-[#E6A05C] text-xs font-semibold tracking-widest">EST. {companyInfo.established}</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 font-semibold text-base">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 font-semibold text-base">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 font-semibold text-base">
              Contact
            </button>
            <a href={`tel:${companyInfo.phoneTel}`} className="flex items-center gap-2 text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 ml-2">
              <Phone size={20} />
              <span className="font-semibold text-base">{companyInfo.phone}</span>
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-[#D4894B] to-[#F0B572] text-[#FFF8DC] px-7 py-3 rounded-lg font-bold text-base hover:from-[#F0B572] hover:to-[#D4894B] transition-all duration-200 hover:scale-105 hover:shadow-lg shadow-[#D4894B]/50 ml-2 border-2 border-[#D4894B]/30"
            >
              Get Quote
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-[#F5E6D3] p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-4 border-t border-[#E6A05C]/20 pt-4">
            <button onClick={() => scrollToSection('services')} className="text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 text-left font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 text-left font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200 text-left font-medium">
              Contact
            </button>
            <a href={`tel:${companyInfo.phoneTel}`} className="flex items-center space-x-2 text-[#F5E6D3] hover:text-[#E6A05C] transition-colors duration-200">
              <Phone size={18} />
              <span className="font-medium">{companyInfo.phone}</span>
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-[#D4894B] to-[#F0B572] text-[#FFF8DC] px-6 py-3 rounded-lg font-semibold transition-colors duration-200 text-center"
            >
              Get Quote
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
